<app-header [progress]="3" [title]="locale.currentTranslation.tripInformationHeader" data-testid="witness-information-header"></app-header>
<div class="base-content-container" data-testid="witness-information-container">
  <div class="headline3" data-testid="witness-information-title">{{ locale.currentTranslation.witnessInformation1 }}
  </div>
  <div class="display-column-gap-24" data-testid="witness-form">
    @for (option of options; track option) {
      <div class="radio-button-base" [attr.data-testid]="'radio-option-' + option.value">
        <div>
          <input type="radio"
            [value]="option.value"
            [formControl]="radioControl"
            [attr.data-testid]="'radio-input-' + option.value"
            [attr.aria-labelledby]="'radio-label-' + option.value">
        </div>
        <div (click)="setOption(option.value)" [attr.data-testid]="'radio-label-container-' + option.value">
          <div class="label1" [attr.id]="'radio-label-' + option.value" [attr.data-testid]="'radio-headline-' + option.value">{{ option.headline }}</div>
          <div class="caption1" [attr.data-testid]="'radio-caption-' + option.value">{{ option.caption }}</div>
        </div>
      </div>
    }
    @if (radioControl.getRawValue() === true) {
      <div class="display-column-gap-24" data-testid="witness-details-section">
        <div class="headline4" data-testid="witness-details-title">
          {{ locale.currentTranslation.witnessInformation2 }}
        </div>
        @for (witness of witnesses; track witness; let i = $index) {
          <div class="display-column-gap-24" [attr.data-testid]="'witness-' + i">
            <div>
              <app-text-input
                [(value)]="witness.surname"
                [placeholder]="locale.currentTranslation.witnessSurNamePlaceholder"
                [showError]="witnessErrors[i] && witnessErrors[i].surname"
                [required]="true"
                [attr.data-testid]="'input-witness-surname-' + i"
                [attr.aria-label]="locale.currentTranslation.witnessSurNamePlaceholder"
              ></app-text-input>
            </div>
            <div>
              <app-text-input
                [(value)]="witness.name"
                [placeholder]="locale.currentTranslation.witnessNamePlaceholder"
                [showError]="witnessErrors[i] && witnessErrors[i].name"
                [required]="true"
                [attr.data-testid]="'input-witness-name-' + i"
                [attr.aria-label]="locale.currentTranslation.witnessNamePlaceholder"
              ></app-text-input>
            </div>
            <div>
              <app-text-input
                [type]="'tel'"
                [(value)]="witness.phone"
                [placeholder]="locale.currentTranslation.witnessPhonePlaceholder"
                [showError]="witnessErrors[i] && witnessErrors[i].phone"
                [errorMessage]="locale.currentTranslation.errorMessagePhoneInvalid"
                [useErrorHandlingV2]="true"
                [required]="true"
                [attr.data-testid]="'input-witness-phone-' + i"
                [attr.aria-label]="locale.currentTranslation.witnessPhonePlaceholder"
              ></app-text-input>
            </div>
            <div>
              <app-text-input
                [type]="'email'"
                [(value)]="witness.email"
                [placeholder]="locale.currentTranslation.witnessEmailPlaceholder"
                [showError]="witnessErrors[i] && witnessErrors[i].email"
                [errorMessage]="'Invalid email format'"
                [useErrorHandlingV2]="true"
                [required]="false"
                [attr.data-testid]="'input-witness-email-' + i"
                [attr.aria-label]="locale.currentTranslation.witnessEmailPlaceholder"
              ></app-text-input>
            </div>
            @if (i > 0) {
              <div class="minimalistic-button" (click)="removeWitness(witness)" [attr.data-testid]="'btn-remove-witness-' + i" role="button" tabindex="0">
                <img ngSrc="assets/img/x-icon.svg" height="20" width="21">
                <div>
                  {{ locale.currentTranslation.witnessInformation4 }}
                </div>
              </div>
            }
            @if (i < witnesses.length && witnesses.length > 1) {
              <div class="divider"></div>
            }
          </div>
        }
        <div class="minimalistic-button" (click)="addWitness()" data-testid="btn-add-witness" role="button" tabindex="0">
          <img ngSrc="assets/img/plus.svg" height="20" width="21">
          <div>
            {{ locale.currentTranslation.witnessInformation3 }}
          </div>
        </div>
      </div>
    }
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
  @if (showMandatoryFieldError) {
    <div class="caption1 error-text" data-testid="mandatory-fields-error" role="alert">
      {{ locale.currentTranslation.errorMessageMandatoryFieldsMissing }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="witness-information-footer"></app-footer>
